import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Hero: React.FC = () => {
  return (
    <header 
      className="hero-micro1"
      style={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '120px 20px 80px 20px',
        backgroundImage: `linear-gradient(to bottom, rgba(18, 18, 18, 0.25) 0%, rgba(18, 18, 18, 0.45) 55%, #121212 98%), url('/micro1-mountain-hero.jpg')`,
        backgroundPosition: 'center 40%',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        overflow: 'hidden',
      }}
    >
      <div className="container" style={{ position: 'relative', zIndex: 2, maxWidth: '880px', margin: '0 auto' }}>
        
        {/* Main Headline (Outfit 400, exact micro1 styling) */}
        <h1 
          style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: 'clamp(36px, 5.5vw, 68px)',
            fontWeight: 400,
            lineHeight: 1.15,
            letterSpacing: '-1.28px',
            color: '#FFFFFF',
            margin: '0 auto 20px',
            maxWidth: '820px'
          }}
        >
          Identity engine to secure modern software &amp; verify every user
        </h1>

        {/* Supporting Subtext */}
        <p 
          style={{
            fontFamily: "'Outfit', sans-serif",
            fontSize: 'clamp(15px, 2vw, 18px)',
            fontWeight: 400,
            lineHeight: 1.6,
            color: '#D7D7D7',
            maxWidth: '620px',
            margin: '0 auto 36px'
          }}
        >
          Zero-trust multi-tenancy, FIDO2 WebAuthn passkeys, and native WhatsApp OTP. 
          Built for high-scale engineering teams without sudden pricing cliffs or captive hashes.
        </p>

        {/* CTA Group */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '14px', flexWrap: 'wrap' }}>
          <Link
            to="/waitlist"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              backgroundColor: '#FFFFFF',
              color: '#121212',
              padding: '12px 24px',
              borderRadius: '9999px',
              fontSize: '14px',
              fontWeight: 500,
              textDecoration: 'none',
              transition: 'transform 0.15s ease, background-color 0.15s ease',
            }}
          >
            <span>Request early access</span>
            <div style={{
              width: '20px',
              height: '20px',
              borderRadius: '50%',
              backgroundColor: '#121212',
              color: '#FFFFFF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <ChevronRight size={13} strokeWidth={2.5} />
            </div>
          </Link>

          <a
            href="#architecture"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              backgroundColor: 'rgba(255, 255, 255, 0.08)',
              border: '1px solid rgba(255, 255, 255, 0.18)',
              color: '#FFFFFF',
              padding: '12px 24px',
              borderRadius: '9999px',
              fontSize: '14px',
              fontWeight: 400,
              textDecoration: 'none',
              backdropFilter: 'blur(8px)',
              WebkitBackdropFilter: 'blur(8px)',
              transition: 'background-color 0.15s ease',
            }}
          >
            <span>Explore architecture</span>
          </a>
        </div>

      </div>

      {/* Floating Bottom Cookie / Status Pill (Matches micro1 bottom pill) */}
      <div 
        style={{
          position: 'absolute',
          bottom: '24px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'rgba(26, 26, 26, 0.85)',
          border: '1px solid rgba(255, 255, 255, 0.12)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          borderRadius: '9999px',
          padding: '8px 18px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          fontSize: '12px',
          color: '#D7D7D7',
          zIndex: 2,
          whiteSpace: 'nowrap'
        }}
        className="hero-bottom-pill"
      >
        <span>By using draway.in, you accept our <Link to="/cookies" style={{ textDecoration: 'underline', color: '#FFFFFF' }}>cookie policy</Link></span>
        <button 
          type="button" 
          onClick={(e) => {
            const el = (e.currentTarget.parentElement as HTMLElement);
            if (el) el.style.display = 'none';
          }}
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
            color: '#FFFFFF',
            border: 'none',
            borderRadius: '9999px',
            padding: '3px 10px',
            fontSize: '11px',
            cursor: 'pointer',
            fontWeight: 500
          }}
        >
          Accept
        </button>
      </div>
    </header>
  );
};

export default Hero;
